import styled from 'styled-components';

export const FileContainer = styled.div`
  &:focus,
  &:active {
    outline: none;
  }
`;
